
import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Separator } from '@/components/ui/separator';

interface CollapsibleSectionProps {
  title: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  rightElement?: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  open,
  onOpenChange,
  children,
  rightElement
}) => {
  return (
    <Collapsible 
      open={open} 
      onOpenChange={onOpenChange}
      className="overflow-hidden mb-1"
    >
      <CollapsibleTrigger className="flex w-full items-center justify-between py-3 hover:text-gray-700">
        <div className="flex items-center justify-between w-full">
          <div className="text-md font-medium">
            {typeof title === 'string' ? <h3>{title}</h3> : title}
          </div>
          <div className="flex items-center space-x-2">
            {rightElement}
            <ChevronDown className={cn(
              "h-4 w-4 transition-transform duration-200",
              open && "rotate-180"
            )} />
          </div>
        </div>
      </CollapsibleTrigger>
      <Separator className="mb-4" /> {/* Increased bottom margin from mb-2 to mb-4 for more padding */}
      <CollapsibleContent className="py-1">
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default CollapsibleSection;
